import axiosInstance from './axiosInstance';

const chatApi = {
    fetchMessages: (userId, dialogId) => axiosInstance.post('/msg/messages', { userId, dialogId }),
    getUserDialogs: (userId) => axiosInstance.get(`/dialogs/user-dialogs?userId=${userId}`),
    startNewDialog: (userId) => axiosInstance.post('/dialogs/new-dialog', { userId }),
    startNewDialogBeginning: (userId) => axiosInstance.post('/dialogs/new-dialog-beginning', { userId }),
    submitRating: (ratingMessageId, rating, comment) => axiosInstance.post('/msg/rate-message', { ratingMessageId, rating, comment }),
    canRateLastMessage: (userId, messageId) => axiosInstance.get(`/msg/can-rate?userId=${userId}&messageId=${messageId}`),
    sendMessageToLawyer: (userId, dialogId, details, question) =>
        axiosInstance.post('/msg/to-lawyer', { userId, dialogId, details, question }),
    sendFile: (formData) => axiosInstance.post('/msg/send-file', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),
    getSession: (userId, messageId) =>
        axiosInstance.get(`/get-session?userId=${userId}&messageId=${messageId}`),
    getPreview: (userId, sessionId, version) =>
        axiosInstance.get(`/preview/${sessionId}/${version}?userId=${userId}`),
    downloadEditedFile: (userId, messageId, fileUrl) =>
        axiosInstance.get(`/edit-files?userId=${userId}&messageId=${messageId}&url=${encodeURIComponent(fileUrl)}`, {
            responseType: 'blob',
        }),
    removeDevice: (userId, typeDevice, deviceId) =>
        axiosInstance.post('/device/remove', { userId, typeDevice, deviceId }),
};

export default chatApi;
